<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><a id="page_2"></a>This book is dedicated to all of SOG’s Medal of Honor recipients and especially to Robert Howard, the most highly decorated American of this or any previous war.</p>
<p class="ded2">May America always find such courageous spirits when she needs them.</p>
<div class="img_container">
<img alt="Images" src="images/f0002-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?9b8b311e